<template>
    <!-- 团队数据 -->
    <div id="agentTeamData">
        <!-- 头部数据更新时间模块 -->
        <headerUpdate></headerUpdate>
        <b-card class="header-top" ref="headerH">
            <div class="header-page-title">
                <div class="title">
                    {{ currentPageTitle }}
                </div>
            </div>
            <!-- 添加 -->
            <!-- <b-button class="add add-tab" variant="primary" @click="handleAdd">
                {{ $t("common.add") }}
            </b-button> -->
            <b-row>
                <b-col lg="9">
                    <!--搜索uid-->
                    <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
                        <b-form-input v-model.trim="searchUid" maxLength="10" placeholder=""></b-form-input>
                    </b-form-group>
                    <!--返佣级别-->
                    <b-form-group class="find-middle" v-if="!disabledReturnLevel">
                        <label>
                            <el-tooltip placement="top">
                                <div slot="content" :style="{ maxWidth: tipWidth }">
                                    {{ $t("lanV4.agentReturnLevelTip") }}
                                </div>
                                <span class="el_tooltip_bor">
                                    {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
                            </el-tooltip>
                        </label>
                        <v-select class="find-select" v-model="level" :options="levelArray">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>
                    <!-- 时间 -->
                    <b-form-group :label="$t('common.date')" class="find-middle">
                        <el-date-picker v-model="dateArray" unlink-panels value-format="yyyy/MM/dd" type="daterange"
                            range-separator="-" :start-placeholder="$t('common.startDate')"
                            :end-placeholder="$t('common.endDate')" @change="handleChangeDate" :clearable="false"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </b-form-group>
                    <!--商户-->
                    <!-- <b-form-group class="find-middle">
                        <label v-if="!disabledBroker">
                            {{ $t("common.clientName") }}
                        </label>
                        <v-select v-if="!disabledBroker" class="find-select" v-model="brokerId" :options="brokerList"
                            :disabled="disabledBroker">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                        <div style="height: 64px" v-if="disabledBroker"></div>
                    </b-form-group> -->
                </b-col>
                <b-col lg="3" class="header-right-btn">
                    <div class="find-middle find-btnBox">
                        <b-button variant="primary" @click="query">
                            {{ $t("common.search") }}</b-button>
                        <b-button variant="light" @click="reset">
                            {{ $t("common.reset") }}</b-button>
                    </div>
                </b-col>
            </b-row>
            <!-- 头部分割线 -->
            <div class="header-top-bottom-bor"></div>
        </b-card>
        <b-card class="table-card">
            <div slot="header">
                <div class="table-title float-left">
                    <!-- 数据总览 标题 -->
                    <!-- {{ $t("lanV4.Datascreening") }} -->
                    <span v-if="pages.total > 0">
                        {{ $t("el.pagination.total", { total: pages.total }) }}
                    </span>
                </div>
                <!-- 导出 -->
                <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
                    :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
                    <svg class="icon icon-16" aria-hidden="true">
                        <use xlink:href="#icon-v4_6_h"></use>
                    </svg>
                    {{ exportButtonText }}
                    <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
                        <use xlink:href="#icon-v4_loading"></use>
                    </svg>
                </b-button>

                <div class="float-right float-right-redio ">
                    <b-input-group>
                        <span @click="setRedio">
                            <v-redio :value="inviteNumRadio"></v-redio>
                            <span class="redio-text">
                                <!-- 不显示邀请人数为0的经纪人 -->
                                {{ $t("lanV4.notInviteNum") }}
                            </span>
                        </span>

                    </b-input-group>
                </div>

            </div>
            <b-row>
                <b-col class="table-section">
                    <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
                        @sort-change="sortChanged" :cell-class-name="addEnClass"
                        :default-sort="{ prop: 'teamUserCount', order: 'descending' }">
                        <template slot="empty">
                            <load-skeleton v-show="loading" :columns="6" :rows="10"
                                :haveLeftNumber="false"></load-skeleton>
                            <h4 class="common-table-noData" v-show="!loading">
                                <img src="../../assets/images/v4_nodata.png" alt="" />
                                <div class="noData-text">
                                    {{ $t("common.noData") }}
                                </div>
                            </h4>
                        </template>
                        <!--  经纪人 -->
                        <el-table-column prop="uid" align="left" :label="$t('lanV4.agentTit')" width="150">
                        </el-table-column>
                        <!--  备注 -->
                        <el-table-column prop="remark" align="right" :label="$t('transfer.remark')" width="150">
                        </el-table-column>
                        <!-- 返佣级别 -->
                        <el-table-column v-if="!disabledReturnLevel" prop="levelName"
                            :label="$t('lanV4.ReturnedCommissionLevel')" align="right" width="150">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentReturnLevelTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!-- 直属下级人数 -->

                        <el-table-column align="right" :label="$t('lanV4.agentDownNum')" prop="directUserCount"
                            width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentDownNumTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentDownNum") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div class="agent-number cursor-pointer" v-if="scope.row.directUserCount > 0&&(roleType==0||roleType==1)"
                                    @click="handleView(scope.row)">
                                    {{ scope.row.directUserCount }}
                                </div>
                                <div class="agent-number cursor-pointer" v-else-if="scope.row.directUserCount > 0&&(roleType==3||roleType==4)&&scope.row.isMaxLevel"
                                    @click="handleView(scope.row)">
                                    {{ scope.row.directUserCount }}
                                </div>
                                <div v-else>
                                    {{ scope.row.directUserCount }}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 团队人数 -->
                        <el-table-column align="right" :label="$t('lanV4.agentTeamNum')" sortable="'custom'"
                            prop="teamUserCount" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentTeamNumTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentTeamNum") }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!-- 入金人数 -->
                        <!-- <el-table-column align="right" :label="$t('lanV4.agentInMoneyNum')" prop="inUserCount"
                            width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentInMoneyNumTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentInMoneyNum") }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                        <!-- 交易人数 -->
                        <!-- <el-table-column align="right" :label="$t('lanV4.agentTradeNum')" prop="treadUserCount"
                            width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentTradeNumTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentTradeNum") }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                        <!-- 总资产USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentTotalassetU')" sortable="'custom'"
                            prop="allAmount" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentTotalassetUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentTotalassetU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.allAmount }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 流入USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentInflowU')" sortable="'custom'"
                            prop="transferIn" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentInflowUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentInflowU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.transferIn }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 流出USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentOutflowU')" sortable="'custom'"
                            prop="transferOut" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentOutflowUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentOutflowU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.transferOut }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 持仓额USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentCurrentPositionU')" sortable="'custom'"
                            prop="holdAmount" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentCurrentPositionUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentCurrentPositionU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.holdAmount }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 交易额USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentTransactionVolumeU')" sortable="'custom'"
                            prop="treadAmount" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentTransactionVolumeUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentTransactionVolumeU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.treadAmount }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 手续费USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentFeeU')" sortable="'custom'"
                            prop="treadFee" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentFeeUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentFeeU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.treadFee }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 返佣USDT -->
                        <el-table-column align="right" :label="$t('lanV4.agentReturnU')" sortable="'custom'"
                            prop="bonusAmount" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        {{ $t("lanV4.agentReturnUTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentReturnU") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span class="mar-r-10">
                                    {{ scope.row.bonusAmount }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </b-col>
            </b-row>
            <b-row class="mar-t-20">
                <b-col>
                    <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size"
                        :pageOptions="pages.options" :currentPage="pages.page" @initialize="pageChange"></v-page>
                </b-col>
            </b-row>
        </b-card>

        <!-- 导出10000条提示 -->
        <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
            no-close-on-backdrop id="code-modal">
            <div class="body-content">
                <div class="expor-number-tip">
                    {{
                        $t("exportsModal.text2", {
                            pagesTotal: pages.total,
                            maxNum: 1000,
                        })
                    }}
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
                        $t("common.cancel")
                    }}</b-button>
                <b-button class="coustom-btn" variant="primary" @click="exports('true')"
                    :class="!isexportIng ? 'lodingSattus' : ''">
                    <template v-if="!isexportIng">
                        {{ $t("common.exportIng") }}
                    </template>
                    <template v-else>
                        <!-- 继续导出 -->
                        {{ $t("exportsModal.text3") }}
                    </template>
                </b-button>
            </template>
        </b-modal>

        <agentRoleModal v-if="modalShow" :modalShow="modalShow" :modalType="modalType" :itemData="itemData"
            @changeModalShow="changeModalShow" @changeModalType="changeModalType" :brokerId="brokerId">
        </agentRoleModal>

        <b-modal
            v-model="downLoadIsShow"
            size="md"
            :title="exportText"
            centered
            scrollable
            no-close-on-backdrop
            @hide="onReset"
        >
        <div class="fileName">
            <span>{{fileName}}</span>
            <svg class="icon btn-loading" aria-hidden="true" style="font-size: 34px" v-if="isDownLoadIng">
                <use xlink:href="#icon-v4_loading_chart"></use>
            </svg>
        </div>
        <template v-slot:modal-footer>
            <b-button
                class="coustom-btn"
                :variant="dowDisbaled ? 'secondary' : 'primary'"
                @click="downloadFile">
                {{ $t("common.download") }}
            </b-button>
        </template>
        </b-modal>
    </div>
    
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTimeDay } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
import agentRoleModal from "./components/agentRoleModal.vue";
import { data } from "jquery";
import { setCookie, getCookie } from "@/apis/cookie";

export default {
    name: "agentRole",
    mixins: [commonMixin],
    components: {
        headerUpdate,
        agentRoleModal,
    },

    data() {
        return {
            searchUid: null,
            level: null,
            levelArray: [],
            dateArray: [new Date().getTime() - 86400000 * 30, new Date().getTime()],
            beginDate: null,
            endDate: null,
            inviteNumRadio: true,
            brokerId: null, //商户id
            brokerList: [],
            pages: {
                page: 1, // 当前页数
                size: 10, // 页数大小
                options: [10, 40, 60, 100], // 页数大小选择
                total: 0, // 总页数
            },
            notData: true,
            loading: true,
            tableList: [],
            modalShow: false,
            isexportIng: true,
            sortBy: null, //预先排序的字段
            sortDesc: true, //预先降序
            sortName: "teamUserCount", //默认排序字段
            sortSet: 1, //默认倒序
            modalType: null,
            itemData: null, //弹窗回显数据
            // 当天之后的时间无法选择
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > window.Date.now();
                },
            },
            fileName: '',
            timer: null,
            dowDisbaled: true,
            fileUrl: null,
            activeFileId: getCookie('isShowDownLoadDialog') ? getCookie('isShowDownLoadDialog') : null,
            downLoadIsShow: getCookie('isShowDownLoadDialog') ? true : false,
            isDownLoadIng: getCookie('isShowDownLoadDialog') ? true : false,
        };
    },
    computed: {
        exportText() {
            return this.$t("common.exportTit");
        },
        exportButtonText() {
            if (!this.isexportIng) {
                return this.$t("common.exportIng"); // '正在导出'
            }
            return this.$t("common.export");
        },
    },

    watch: {
        brokerId(v) {
            if (v) {
                // this.getData();
            }
        },
        level(v) {
            if (v) {
                this.getData();
            }
        },
        searchUid(v) {
            if (v) {
                this.$nextTick(() => {
                    this.searchUid = fixInput(v, 0, { num: 1 });
                });
            }
        },
    },
    created() {
        this.getLastMonthOne()
        this.getReturnLevel();
        this.getBrokerList();
        this.handleChangeDate()
        if(this.activeFileId) {
            this.getexportinfo();
        }
    },
    methods: {
        // 选择时间
        handleChangeDate() {
            this.beginDate = this.dateArray[0];
            this.endDate = this.dateArray[1];
        },
        // 单选
        setRedio() {
            this.inviteNumRadio = !this.inviteNumRadio
            this.query()
        },
        // 获取商户列表
        getBrokerList() {
            this.$http({
                url: this.$store.state.url.common.getBrokerList,
            }).then(({ data, code, msg }) => {
                if (data && code.toString() === "0") {
                    let arr = [];
                    // if (this.roleType === 1) {
                    //   arr.push({ label: this.$t("common.all"), value: null });
                    // }
                    if (data.length) {
                        data.map((item) => {
                            arr.push({ label: item.brokerName, value: item.id });
                        });
                        this.brokerList = arr;
                        this.brokerId = arr[0];
                    }
                } else {
                    this.$bus.$emit("alert", { type: "error", message: msg });
                }
            });
        },
        // 获取返佣级别下拉
        getReturnLevel() {
            this.$http({
                url: this.$store.state.url.agent.level_list,
                params: {
                    hasSelfReturn: 0, //不包含自返佣
                },
            }).then(({ data, code, msg }) => {
                if (data && code.toString() === "0") {
                    let arr = [];
                    arr.push({ label: this.$t("common.all"), value: null });
                    if (data) {
                        data.levelArray.map((item) => {
                            arr.push({ label: item.levelName, value: item.level });
                        });
                        this.levelArray = arr;
                        this.level = this.returnLevelDefaultValue() //默认一级
                    }
                } else {
                    this.$bus.$emit("alert", { type: "error", message: msg });
                }
            });
        },
        //获取保证金币种默认值
        returnLevelDefaultValue() {
            let data = [];
            if (this.levelArray && this.levelArray.length) {
                this.levelArray.forEach((item) => {
                    if (item.value == 1) {
                        data = item;
                    }
                });
            }
            return data;
        },
        // 点击所含经纪人数跳转
        handleView(row) {
            const queryObj = {
                agentUid: row.uid, //经纪人uid
                startTime: this.dateArray
                    ? new window.Date(this.beginDate).getTime()
                    : null,
                endTime: this.dateArray
                    ? new window.Date(this.endDate).getTime()
                    : null,
            };
            this.$router.push({ path: "/agentDownLevel", query: queryObj });
        },
        // 删除弹窗关闭
        handlePopoverClose() {
            document.getElementById("agentRole").click();
        },
        // 添加
        handleAdd() {
            this.itemData = null;
            this.modalType = "Add";
            this.modalShow = true;
        },
        //编辑
        handleEdit(row) {
            this.modalType = "Edit";
            this.itemData = row;
            this.modalShow = true;
        },

        // 删除
        handleDelete(row) {
            if (row.agentNumber == 0) {
                this.$http({
                    url: this.$store.state.url.agent.co_agent_role_set,
                    params: {
                        roleId: row.id,
                        status: 0,
                    },
                }).then(({ code, msg }) => {
                    this.handlePopoverClose();
                    if (code.toString() === "0") {
                        this.$bus.$emit("alert", { type: "success", message: msg });
                        this.getData();
                    } else {
                        this.$bus.$emit("alert", { type: "error", message: msg });
                    }
                });
            } else {
                this.$bus.$emit("alert", {
                    type: "error",
                    message: this.$t("lanV4.deleteAgent"),
                });
            }
        },
        // 英文数字字体
        addEnClass({ row, column }) {
            switch (column.property) {
                case "uid":
                    return "enNum";
                case "pid":
                    return "enNum";
                case "tradeAmount":
                    return "enNum";
                case "fee":
                    return "enNum";
                case "returnAmount":
                    return "enNum";
            }
        },
        // 排序变化
        sortChanged(ctx) {
            switch (ctx.prop) {
                case "directUserCount":
                    this.sortName = "directUserCount";
                    break;
                case "teamUserCount":
                    this.sortName = "teamUserCount";
                    break;
                case "allAmount":
                    this.sortName = "allAmount";
                    break;
                case "transferIn":
                    this.sortName = "transferIn";
                    break;
                case "transferOut":
                    this.sortName = "transferOut";
                    break;
                case "holdAmount":
                    this.sortName = "holdAmount";
                    break;
                case "treadAmount":
                    this.sortName = "treadAmount";
                    break;
                case "treadFee":
                    this.sortName = "treadFee";
                    break;
                case "bonusAmount":
                    this.sortName = "bonusAmount";
                    break;
            }
            if (ctx.order === "descending") {
                this.sortSet = 1;
            } else if (ctx.order === "ascending") {
                this.sortSet = 0;
            } else {
                this.sortSet = null;
                this.sortName = null;
            }
            this.getData();
        },
        // 搜索
        query() {
            this.pages.page = 1;
            this.loading = true;
            this.getData();
        },
        // 重置
        reset() {
            this.getLastMonthOne();
            this.handleChangeDate();
            this.level = this.returnLevelDefaultValue()
            this.searchUid = null

        },
        // 最近一月
        getLastMonthOne() {
            var end = new window.Date(new window.Date() - 1000 * 60 * 60 * 24);
            var year = end.getFullYear();
            var month = end.getMonth() + 1; //0-11表示1-12月
            var day = end.getDate();
            var dateObj = {};
            dateObj.end = year + "-" + month + "-" + day;
            var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
            if (month - 1 <= 0) {
                //如果是1月，年数往前推一年<br>
                dateObj.start = year - 1 + "-" + 12 + "-" + day;
            } else {
                var startMonthDay = new window.Date(
                    year,
                    parseInt(month) - 1,
                    0
                ).getDate();
                if (startMonthDay < day) {
                    //1个月前所在月的总天数小于现在的天日期
                    if (day < endMonthDay) {
                        //当前天日期小于当前月总天数
                        dateObj.start =
                            year +
                            "-" +
                            (month - 1) +
                            "-" +
                            (startMonthDay - (endMonthDay - day));
                    } else {
                        dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
                    }
                } else {
                    dateObj.start = year + "-" + (month - 1) + "-" + day;
                }
            }
            this.beginDate = new window.Date(
                dateObj.start.replace(/-/g, "/")
            ).getTime();
            this.endDate = new window.Date(dateObj.end.replace(/-/g, "/")).getTime();

            this.dateType = 1;
            this.dateArray = [
                formatTimeDay(this.beginDate),
                formatTimeDay(this.endDate),
            ];
        },
        // 获取数据列表
        getData() {
            console.log(this.sortName, 'cdsfsd')
            this.loading = true;
            this.tableList = [];
            const paramsData = {
                pageNum: this.pages.page,
                pageSize: this.pages.size,
                sortParam: this.sortName,
                sortSet: this.sortSet,
                isExport: 0,
                uid: this.searchUid,
                startTime: this.dateArray
                    ? new window.Date(this.beginDate).getTime()
                    : null,
                endTime: this.dateArray
                    ? new window.Date(this.endDate).getTime()
                    : null,
                level: this.level ? this.level.value : null,
                noInvite: this.inviteNumRadio ? 1 : 0,// 1:不包含没邀请别人的经纪人，0:包含没邀请别人的经纪人
                subAdminUid: null,//查询下级uid
            };
            this.$http({
                url: this.$store.state.url.agent.co_agent_team,
                params: paramsData,
                // method: "get",
                // apiType: "fe-json-server",
            })
                .then(({ data, code, msg }) => {
                    this.loading = false;
                    if (data && code.toString() === "0") {
                        this.setData(data.pageInfo);
                    } else {
                        this.$bus.$emit("alert", { type: "error", message: msg });
                    }
                })
                .catch((e) => {
                    this.loading = false;
                });
        },
        setData(datas) {
            const { total, rows } = datas;
            this.pages.total = total ? total : 0;
            let arr = [];
            if (rows && rows.length) {
                rows.map((item, index) => {
                    arr.push({
                        sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
                        uid: item.uid,//经纪人
                        remark: item.remark,//备注
                        levelName: item.levelName,//返佣级别
                        directUserCount: item.directUserCount, //直属下级人数
                        teamUserCount: item.teamUserCount,//团队人数
                        // inUserCount: item.inUserCount,//入金人数
                        // treadUserCount: item.treadUserCount,//交易人数
                        allAmount: item.allAmount, //总资产(usdt)
                        transferIn: item.transferIn, //流入(usdt)
                        transferOut: item.transferOut,//流出(USDT)
                        holdAmount: item.holdAmount,//持仓额(USDT)
                        treadAmount: item.treadAmount,//交易额(USDT)
                        treadFee: item.treadFee,//手续费(USDT)
                        bonusAmount: item.bonusAmount,//返佣(USDT)
                        isMaxLevel:item.isMaxLevel,//是否可以点下级 / 0:最大等级不可点击 1:没到最大等级可以点击
                    });
                });
            }
            if (arr.length === 0) {
                this.notData = true;
            }
            this.tableList = arr;
        },
        // 导出
        exports(istrue) {
            if (
                istrue !== "true" &&
                this.pages.total &&
                Number(this.pages.total) > 1000
            ) {
                this.exportsModalShow = true;
            } else {
                if (!this.isexportIng) return;
                this.isexportIng = false;
                const paramsData = {
                    pageNum: this.pages.page,
                    pageSize:1000,
                    sortParam: this.sortName,
                    sortSet: this.sortSet,
                    isExport: 1,
                    uid: this.searchUid,
                    startTime: this.dateArray
                        ? new window.Date(this.beginDate).getTime()
                        : null,
                    endTime: this.dateArray
                        ? new window.Date(this.endDate).getTime()
                        : null,
                    level: this.level ? this.level.value : null,
                    noInvite: this.inviteNumRadio ? 1 : 0,// 1:不包含没邀请别人的经纪人，0:包含没邀请别人的经纪人
                    subAdminUid: null,//查询下级uid
                };

                this.outExcel(
                    this.$store.state.url.agent.co_agent_team,
                    paramsData,
                    "increment-api"
                ).then((datas) => {
                    if (datas.code === "0") {
                        this.activeFileId = datas.data.id;
                        this.getexportinfo();
                        setTimeout(() => {
                            this.isexportIng = true;
                        }, 500);
                    } else {
                        this.$bus.$emit("alert", {type: "error",message: this.$t("common.exportError")}); // 导出失败
                    }
                });
            }
        },
        getexportinfo(){
            this.downLoadIsShow = true;
            this.isDownLoadIng = true;
            this.dowDisbaled = true;
            setCookie('isShowDownLoadDialog', this.activeFileId);
            this.exportsShowDialog();
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.exportsShowDialog();
            }, 2000)
        },
    
        exportsShowDialog() {
            const paramsData = {
                id: this.activeFileId
            };
            this.outExcel(
                    this.$store.state.url.agent.get_export_info,
                    paramsData,
                    "increment-api"
                ).then((datas) => {
                if (datas.code === "0") {
                    if(!datas.data) {
                        this.onReset();
                        clearInterval(this.timer);
                    }
                    this.fileName = datas.data.name;
                    if(datas.data.status === 0) {
                        clearInterval(this.timer);
                        this.dowDisbaled = false;
                        this.isDownLoadIng = false;
                        this.fileUrl = datas.data.url;
                    }
                } else {
                    this.$bus.$emit("alert", {
                        type: "error",
                        message: this.$t("common.exportError"),
                    }); // 导出失败
                    this.onReset();
                }
            });
            
        },
        downloadFile() {
            if(this.fileUrl && !this.dowDisbaled) {
                const link = document.createElement('a');
                link.href = this.fileUrl;
                link.download = this.fileName; // 这里可以指定下载的文件名
                // 触发点击事件下载文件
                link.click();
                this.$bus.$emit("alert", {
                    type: "success",
                    message: this.$t("common.exportSuccess"),
                }); // 导出成功
                this.exportsModalShow = false;
                this.onReset();
            }
        },
        changeModalShow(data) {
            this.modalShow = data;
        },
        changeModalType(data) {
            this.modalType = data;
        },
        onReset() {
            this.exportsModalShow = false;
            
            clearInterval(this.timer);
            this.downLoadIsShow = false;
            this.dowDisbaled = true;
            this.fileUrl = '';
            this.isDownLoadIng = false;
            setCookie('isShowDownLoadDialog', '');


        },
        // 分页
        pageChange(data) {
            const { page, pageSize } = data;
            this.pages.page = page;
            this.pages.size = pageSize;
            const v = "page";
            this.getData(v);
        },
    },
};
</script>

<style lang="scss">
#agentTeamData {

    .add-tab {
        position: absolute;
        top: 16px;
        right: 26px;
    }

    .custom-control {
        top: 5px !important;
    }

    .agent-number {
        color: #095be8;
        cursor: pointer;
    }

    .float-right-redio {
        margin-top: 13px;

        .redio-text {
            margin-left: 8px;
            color: #37435B;
            font-family: HarmonyOS-Regular;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            position: relative;
            top: 1px;
            margin-right: 11px;
            cursor: pointer;
        }
        .redio-box {
            margin-left: 30px;
        }
    }
}
.fileName {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
        margin-right: 10px;
        display: block;
        max-width: 360px;
    }
}
</style>